import type { QueryClient, QueryFilters } from '@tanstack/react-query';

/**
 * A read already on its way was issued before the patch existed, and an infinite query builds
 * its next data from the pages it held when that read started — so whichever kind of read is in
 * flight, letting it land as-is drops the patch.
 *
 * A refetch of the pages on screen is worth aborting outright. Some reads are not: a Load more is
 * the reader's own click, which cancelling would silently swallow, and a first read would only be
 * joined by a restart. Those are waited out instead, at the cost of one extra read once they land.
 */
export const reReadPatchedQuery = async (
  queryClient: QueryClient,
  filters: QueryFilters,
  shouldWaitForRead: boolean,
) => {
  if (shouldWaitForRead) {
    await queryClient.refetchQueries(filters, { cancelRefetch: false });
  }

  await queryClient.refetchQueries(filters);
};
